// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-header {
    display: none;
    align-items: center;
    background-color: white;
    border-bottom: 1px solid #E1E9EF;
    height: 80px;
    justify-content: space-between;
    width: 100%;
    position: relative;
    z-index: 3;
  }
  
  .hamburger-icon {
    margin-left: 20px;
    cursor: pointer;
  }
  
  .logo-container {
    margin-right: 20px;
  }
  
  .logo {
    width: 40px;
    height: 40px;
  }
  
  .mobile-menu {
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    background-color: #E1E9EF; ;
    border-top: 1px solid #E1E9EF;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: left;
  }
  
  .mobile-menu-item {
    width: fit-content;
    padding: 10px 0;
    cursor: pointer;
  }
  
  .mobile-lang-options {
    display: flex;
    flex-direction: column;
    align-items: left;
  }
  
  .flag-option {
    display: flex;
    align-items: left;
    padding: 5px 0;
    cursor: pointer;
  }
  
  .flag-icon {
    width: 24px;
    height: 16px;
    margin-right: 5px;
  }
  
  .logout-button {
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    background-color: transparent;
    display: flex;
    justify-content: left;
    align-items: left;
  }
  
  .logout-button-span {
    margin-left: 5px;
  }
  

  @media (max-width: 520px) {
    .mobile-header {
      display: flex;
    }
    .logout-button {
        height: 3rem;
        margin-top: 1rem;
    }
    .mobile-menu-line{
        height: 1px;
        margin: 0 2rem;
        background-color: #252630 !important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/MobileMenu/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,YAAY;IACZ,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE;MACE,aAAa;IACf;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,cAAc;QACd,oCAAoC;IACxC;EACF","sourcesContent":[".mobile-header {\n    display: none;\n    align-items: center;\n    background-color: white;\n    border-bottom: 1px solid #E1E9EF;\n    height: 80px;\n    justify-content: space-between;\n    width: 100%;\n    position: relative;\n    z-index: 3;\n  }\n  \n  .hamburger-icon {\n    margin-left: 20px;\n    cursor: pointer;\n  }\n  \n  .logo-container {\n    margin-right: 20px;\n  }\n  \n  .logo {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .mobile-menu {\n    position: absolute;\n    top: 80px;\n    left: 0;\n    width: 100%;\n    background-color: #E1E9EF; ;\n    border-top: 1px solid #E1E9EF;\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n  }\n  \n  .mobile-menu-item {\n    width: fit-content;\n    padding: 10px 0;\n    cursor: pointer;\n  }\n  \n  .mobile-lang-options {\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n  }\n  \n  .flag-option {\n    display: flex;\n    align-items: left;\n    padding: 5px 0;\n    cursor: pointer;\n  }\n  \n  .flag-icon {\n    width: 24px;\n    height: 16px;\n    margin-right: 5px;\n  }\n  \n  .logout-button {\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    background-color: transparent;\n    display: flex;\n    justify-content: left;\n    align-items: left;\n  }\n  \n  .logout-button-span {\n    margin-left: 5px;\n  }\n  \n\n  @media (max-width: 520px) {\n    .mobile-header {\n      display: flex;\n    }\n    .logout-button {\n        height: 3rem;\n        margin-top: 1rem;\n    }\n    .mobile-menu-line{\n        height: 1px;\n        margin: 0 2rem;\n        background-color: #252630 !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
